// @flow
import * as React from "react";

import { ConfigProvider, theme } from "antd";

type Props = {
  children: React.Node,
};

function AntdConfigProvider({ children }: Props): React.Node {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.compactAlgorithm,
      }}>
      {children}
    </ConfigProvider>
  );
}

export default AntdConfigProvider;
